/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseKingDifferenceMediaCf013Fragment, KingDifferenceMediaCf013Fragment, FullKingDifferenceMediaCf013Fragment} from '@amblique/contentful/app/contentful/fragments/king-difference-media-cf013';

/**
 * Get a single KingDifferenceMediaCf013 by ID (base - scalars only)
 */
export const getBaseKingDifferenceMediaCf013ById = gql`
  ${BaseKingDifferenceMediaCf013Fragment}

  query GetBaseKingDifferenceMediaCf013ById($id: String!, $locale: String!, $preview: Boolean) {
    kingDifferenceMediaCf013(id: $id, locale: $locale, preview: $preview) {
      ...BaseKingDifferenceMediaCf013Fragment
    }
  }
`;

/**
 * Get a single KingDifferenceMediaCf013 by ID (standard - 1 level deep)
 */
export const getKingDifferenceMediaCf013ById = gql`
  ${KingDifferenceMediaCf013Fragment}

  query GetKingDifferenceMediaCf013ById($id: String!, $locale: String!, $preview: Boolean) {
    kingDifferenceMediaCf013(id: $id, locale: $locale, preview: $preview) {
      ...KingDifferenceMediaCf013Fragment
    }
  }
`;

/**
 * Get a single KingDifferenceMediaCf013 by ID (full - 2 levels deep)
 */
export const getFullKingDifferenceMediaCf013ById = gql`
  ${FullKingDifferenceMediaCf013Fragment}

  query GetFullKingDifferenceMediaCf013ById($id: String!, $locale: String!, $preview: Boolean) {
    kingDifferenceMediaCf013(id: $id, locale: $locale, preview: $preview) {
      ...FullKingDifferenceMediaCf013Fragment
    }
  }
`;

/**
 * Get all KingDifferenceMediaCf013 entries with pagination (base - scalars only)
 */
export const getBaseKingDifferenceMediaCf013s = gql`
  ${BaseKingDifferenceMediaCf013Fragment}

  query GetBaseKingDifferenceMediaCf013s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [KingDifferenceMediaCf013Order]
    $where: KingDifferenceMediaCf013Filter
    $preview: Boolean
  ) {
    kingDifferenceMediaCf013Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseKingDifferenceMediaCf013Fragment
      }
    }
  }
`;

/**
 * Get all KingDifferenceMediaCf013 entries with pagination (standard - 1 level deep)
 */
export const getKingDifferenceMediaCf013s = gql`
  ${KingDifferenceMediaCf013Fragment}

  query GetKingDifferenceMediaCf013s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [KingDifferenceMediaCf013Order]
    $where: KingDifferenceMediaCf013Filter
    $preview: Boolean
  ) {
    kingDifferenceMediaCf013Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...KingDifferenceMediaCf013Fragment
      }
    }
  }
`;

/**
 * Get all KingDifferenceMediaCf013 entries with pagination (full - 2 levels deep)
 */
export const getFullKingDifferenceMediaCf013s = gql`
  ${FullKingDifferenceMediaCf013Fragment}

  query GetFullKingDifferenceMediaCf013s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [KingDifferenceMediaCf013Order]
    $where: KingDifferenceMediaCf013Filter
    $preview: Boolean
  ) {
    kingDifferenceMediaCf013Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullKingDifferenceMediaCf013Fragment
      }
    }
  }
`;
